import C from 'classnames';
import * as React from 'react';
import { Button } from '../..';
interface ISearchFormProps {
  children?: React.ReactNode;
  onSearch?: (query?: string) => void;
  button?: boolean;
  flush?: boolean;
}

export const SearchForm: React.FunctionComponent<ISearchFormProps> = ({
  flush = true,
  button = true,
  ...props
}: ISearchFormProps) => {
  const [query, setQuery] = React.useState('');

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    props.onSearch && props.onSearch(query);
  };

  const onClick = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e && e.preventDefault();
    props.onSearch && props.onSearch(query);
  };

  return (
    <form onSubmit={onSubmit}>
      <div
        className={C(
          'input-group',
          'align-items-center',
          flush && 'input-group-flush',
          !button && 'input-group-merge'
        )}
      >
        {(flush || (!button && !flush)) && (
          <div className="input-group-prepend">
            <div className="input-group-text">
              <span className="fe fe-search"></span>
            </div>
          </div>
        )}
        <input
          type="search"
          className="form-control form-control-prepended search"
          placeholder="Search"
          onChange={onChange}
          value={query}
        />
        {button &&
          (flush ? (
            <Button variant="white" onClick={onClick}>
              <i className="fe fe-search"></i>
            </Button>
          ) : (
            <div className="input-group-append">
              <Button variant="primary" onClick={onClick}>
                <span className="fe fe-search"></span>
              </Button>
            </div>
          ))}
      </div>
    </form>
  );
};
